import MediumDealCard from '@ulta/components/MediumDealCard/MediumDealCard';

export default MediumDealCard;